import { DefaultLink } from 'hb-react/frontoffice/components/Link';

import style from './index.module.scss';

const UploadButton = ({ icon: initialIcon, onClick, url, label, onDelete }) => {
  const icon = initialIcon || 'icon-file';

  return (
    <span
      className={`button button--white uk-button ${style['component--reset']}`}
      onClick={onClick}
    >
      <DefaultLink href={url} target="_blank" className="color-gray">
        <i className={`${icon} soft-half--right`} />
        {label || I18n.t('global.upload_file')}
      </DefaultLink>
      {onDelete && (
        <i
          className="icon-multiply soft-half--left icon-size--070"
          onClick={onDelete}
        />
      )}
    </span>
  );
};

export default UploadButton;
